import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./css/Modal.css";

function shouldIgnoreOutsideClick(e) {
  return (
    e.target.closest?.(".p-dropdown-panel") ||
    e.target.closest?.(".p-datepicker") ||
    e.target.closest?.(".p-overlaypanel") ||
    e.target.closest?.(".p-dialog")
  );
}

export default function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  className = "",
  cardRef,
  overlay,
}) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <>
          {/* Backdrop (optional now, but keep) */}
          <motion.div
            className="uiModalBackdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onMouseDown={(e) => {
              if (shouldIgnoreOutsideClick(e)) return;
              onClose?.();
            }}
          />

          {/* Wrap (likely full screen) */}
          <motion.div
            className="uiModalWrap"
            initial={{ opacity: 0, y: 10, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.98 }}
            transition={{ duration: 0.18 }}
            role="dialog"
            aria-modal="true"
            aria-label={title}
            // ✅ Close ONLY when clicking the wrap itself (outside the card)
            onMouseDown={(e) => {
              if (shouldIgnoreOutsideClick(e)) return;
              if (e.target === e.currentTarget) onClose?.();
            }}
          >
            {/* ✅ Stop propagation ONLY on the card */}
            <div
              ref={cardRef}
              className={"uiModalCard " + className}
              onMouseDown={(e) => e.stopPropagation()}
            >
              <div className="uiModalHeader">
                <div className="uiModalTitle">{title}</div>
                <button
                  type="button"
                  className="uiModalClose"
                  onClick={onClose}
                  aria-label="Close"
                  title="Close"
                >
                  ✕
                </button>
              </div>

              <div className="uiModalBody">{children}</div>

              {footer && <div className="uiModalFooter">{footer}</div>}
              {overlay}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
